<template>
    <div class="contaner">
      <div class="posfix"  v-if="!isApp">
        <div class="flexbox fle-sa headerbox">
            <div class="logobox tex2en"><img src="../assets/imgs/logo.png"/>{{$t('logo')}}</div>
            <div class="flexbox  fle-sa">
                <router-link exact to="/home/homePage"><i class="el-icon-s-home"></i>{{$t('menu.home')}}</router-link>
                <router-link to="/home/manageMoney"><i class="el-icon-s-finance"></i>{{$t('menu.manageMoney')}}
                </router-link>
                <router-link to="/home/levelup"><i class="el-icon-medal"></i>{{$t('menu.vip')}}</router-link>
                <router-link :to="isApp?'/home/accountApp':'/home/account'"><i class="el-icon-s-custom"></i>{{$t('menu.account')}}
                </router-link>
            </div>
            <div class="usebox flexbox  fle-sa">
                <div @click="jumpmsg()" class="btnn"><i class="el-icon-message-solid"></i></div>
                <div class="flexbox fle-sb"><span>{{username}}</span>
                    <div class="btnn padl2" v-if="username" @click="logout()">{{$t('logout')}}</div>
                    <div class="btnn padl2" v-else @click="logout()">{{$t('login')}}</div>
                </div>
                <div class="nature btnn">
                    <el-popover
                            placement="bottom"
                            width="80"
                            trigger="click">
                        <div class="lanlist">
                            <div :class="lang==item.name?'activeList':''" @click="changlang(item.name, item)" v-for="(item, index) in langList" :key="index">
                                <img :src="item.flag"/>{{item.full_name}}
                            </div>
                        </div>
                        <div slot="reference"><img :src="currentLang.flag"/>{{currentLang.full_name}}</div>
                    </el-popover>
                </div>
            </div>
        </div>
      </div>
        <div :class="['contentbox',!isApp?'padt60':'']">
            <router-view @change_bread="change_bread($event)"></router-view>
        </div>
        <div class="footerbox" v-if="!isApp">
            <div class="footercen flexbox fle-sb">
                <div>
                    <div>{{$t('logo')}}</div>
                    <div class='flexbox'>
                        <router-link to="/home/homePage">{{$t('menu.home')}}</router-link>
                        <router-link to="/home/manageMoney">{{$t('menu.manageMoney')}}</router-link>
                        <router-link to="/home/levelup">{{$t('menu.vip')}}</router-link>
                        <router-link to="/home/account">{{$t('menu.account')}}</router-link>
                    </div>
                </div>
                <div>
                    {{$t('index.email')}}
                    <div class="fonwbig">{{customer_service_email}}</div>
                </div>
            </div>
        </div>
        <div class="flexbox fle-sa headerbox"
             v-if="isApp&&(routeName==='/home/homePage'||routeName==='/home/accountApp'||routeName==='/home/manageMoney'||routeName==='/home/levelup')">
            <div class="flexbox  fle-sa  fle100">
                <router-link exact to="/home/homePage"><i class="el-icon-s-home"></i>
                    <div>{{$t('menu.home')}}</div>
                </router-link>
                <router-link to="/home/manageMoney"><i class="el-icon-s-finance"></i>
                    <div>{{$t('menu.manageMoney')}}</div>
                </router-link>
                <router-link to="/home/levelup"><i class="el-icon-medal"></i>
                    <div>{{$t('menu.vip')}}</div>
                </router-link>
                <router-link :to="isApp?'/home/accountApp':'/home/account'"><i class="el-icon-s-custom"></i>
                    <div>{{$t('menu.account')}}</div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import Cookies from 'js-cookie'
    import {
        getInfo
    } from '@/api/login.js'

    export default {
        name: 'container_box',
        components: {},
        computed: {
            isApp() {
                return document.documentElement.clientWidth < 800 ? true : false
            },
            routeName() {
                console.log(this.$route.path)
                return this.$route.path
            }
        },
        data() {
            return {
                lang: Cookies.get('lang'),
                langList: [],
                currentLang: {},
                username: '',
                customer_service_email: '',
            }
        },
        mounted() {
            getInfo().then(res => {
                if (res.code == 1) {
                    this.username = res.data.username
                    this.customer_service_email = res.data.customer_service_email
                    this.langList = res.data.langList
                    if(this.langList){
                        for(let index = 0; index < this.langList.length; index++){
                            let item = this.langList[index]
                            if(this.lang == item.name){
                                this.currentLang = item
                                break
                            }
                        }
                    }
                }


            }).catch(_ => {

            });
        },

        methods: {
            changlang(lang, item) {
                if(lang != this.lang){
                    this.lang = lang
                    this.currentLang = item
                    this.$i18n.locale = lang
                    Cookies.set('lang', lang)
                    Cookies.set('lang_var', item.lang_var)
                    this.$router.go(0)
                }
            },
            logout() {
                this.username = null
                this.$router.push({path: '/login'})
            },
            change_bread(e) {
                this.username = e
            },
            jumpmsg() {
                this.$router.push({path: '/home/msglist'})
            },
        }
    }
</script>
<style lang="scss" scoped>
    .contaner {
      .posfix{
        position: fixed;
        width: 100%;
        z-index: 22;
        background: #000;
        border-bottom: 1px solid #838383;
      }
      .padt60{
        padding-top: 80px;
        box-sizing: border-box;
      }
      .tex2en{
          overflow:hidden;
          text-overflow:ellipsis;
          display:-webkit-box;
          -webkit-box-orient:vertical;
          -webkit-line-clamp:2; // 2行
        }
        .logobox {
            img {
                width: 50px;
                height: 50px;
                vertical-align: middle;
                padding-right: 10px;
            }
        }

        .headerbox {
            height: 80px;
            // line-height: 80px;
            align-items: center;
            font-size: 24px;
            background: #000;
            color: #fff;

            a {
                font-size: 24px;
                margin: 0px 40px;
                color: #fff;
                text-decoration: #fff;

                &.router-link-active {
                    color: rgb(36, 50, 243);
                }
            }

            .nature {
                img {
                    width: 60px;
                    height: 40px;
                    padding-right: 10px;
                    vertical-align: middle;
                }
            }

            .usebox {
                & > div {
                    margin: 0px 20px;
                }
            }
        }

        .contentbox {

        }

        .fle100 {
            width: 100%;
            border-top: 1px solid #3e3e3e;
        }

        .footerbox {
            height: 160px;
            border-top: 3px solid #b1b1b1;
            color: #fefefe;
            text-align: left;
            line-height: 40px;

            .footercen {
                width: 1200px;
                margin: 0px auto;
                padding: 20px;
                box-sizing: border-box;
                font-size: 20px;

                a {
                    color: #fefefe;
                    text-decoration: none;
                    margin: 10px 30px 10px 0px;
                }
            }
        }
    }

</style>
